export default __webpack_public_path__ + "static/media/car06.505a72b4.jpg";